import { createSlice } from "@reduxjs/toolkit";
import { getConnectionRequests, getHelpRequests, updateIsResolved } from "./Thunk";

export const saHelpDesk = createSlice({
  name: "saHelpDesk",
  initialState: {
    isLoading: false,
    connectionRequests: [],
    helpRequests: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getConnectionRequests.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getConnectionRequests.fulfilled, (state, action) => {
      state.connectionRequests = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getHelpRequests.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getHelpRequests.fulfilled, (state, action) => {
      state.helpRequests = action.payload;
      state.isLoading = false;
    });

    builder.addCase(updateIsResolved.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateIsResolved.fulfilled, (state, action) => {
      state.isLoading = false;
    });
  },
});

export const {} = saHelpDesk.actions;

export default saHelpDesk.reducer;
